import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { FormValidationService } from '../../../validations/form-validation-service'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import {
    ReactiveFormsModule,
    FormBuilder,
    FormsModule,
    FormGroup,
    FormControl,
    Validators,
    FormControlDirective,
    FormGroupDirective
} from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { SaveEmailModel } from '../../models/saveEmailModel'
import { SubmitEmailForm } from '../../models/submit-email-model'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { SendEmailModel } from '../../models/SendEmailModel'
import { CommonGateway } from '../../../common/gateways/common-gateway'
import { PortalGlobals } from '../../../portalglobals'
import { GoodStandingModel } from '../../../common/models/good-standing-model'
import { TrainingCertificatesGateway } from '../../../training/gateways/training-certificates-gateway'
import { EnrollmentSettingModel } from '../../../enrollment/models/EnrollmentSettingModel'
import { LicenseApptGateway } from '../../../user-management/gateways/license-appt-gateway'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { UserDataService } from '../../../user-management/gateways/user-data-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import * as moment from 'moment'

@Component({
    providers: [FormControlDirective, FormGroupDirective],
    selector: 'SendEmailEnrollment',
    templateUrl: 'Send-EmailEnrollment.html',
    styleUrls: ['Send-EmailEnrollment.scss']
})
export class SendEmailEnrollmentComponent implements OnInit {
    @Input() states: State[]

    enableSubmit: boolean
    beneficiaryNameError: string
    specialCharacterBeneficiaryNameError: string
    beneficiaryEmailError: string
    specialCharacterbeneficiaryEmailError: string

    radioCheckError: string
    isRaddioConsidered: boolean
    hasError: boolean
    isSuccess: boolean
    stateSelectError: string
    licenseError: string
    islicensed
    selectedStateText: string

    @Output() onValueChange: EventEmitter<SubmitEmailForm> = new EventEmitter<SubmitEmailForm>()
    @Input() emailSubmitForm: SubmitEmailForm
    options: ValidatedRadioButtonModel[] = []
    isAgree: boolean
    emailSendConfirmation: string
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    haserror: boolean = false
    trainingMsg: boolean = false
    backgroundMsg: boolean = false
    trainingFailedMsg: boolean = false
    licencemsg: boolean = false
    validAgent: boolean = false
    isRequired: boolean = false
    hasEmailError: boolean = false
    for2022: boolean = false
    for2023: boolean = false
    fortemp2023: boolean = false
    EmailError: string = ''
    @ViewChild('focusableEleTop') focusableEleTop: ElementRef

    constructor(
        private router: Router,
        formValidationService: FormValidationService,
        private _licenseAppGateway: LicenseApptGateway,
        private _stateGateway: StateGateway,
        private _enrollGateWay: EnrollmentGateway,
        private route: ActivatedRoute,
        private commonGateway: CommonGateway,
        public _global: PortalGlobals,
        private trainingCertificatesGateway: TrainingCertificatesGateway,
        private _currentUserGateway: CurrentUserGateway,
        private userdataservice: UserDataService,
        private _networkUserAccessGateway: UserAccessGateway,
        private routers: Router
    ) {}

    ngOnInit(): void {
        if (localStorage.getItem('GoodStandingParams') != null) {
            this.goodStandingValues = JSON.parse(localStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                this.haserror = true
                this.validAgent = false
                //this.beneficiaryNameError = 'You are not in good standing either you have not passed training or background check is failed.'
                this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                this.licencemsg = !this.goodStandingValues.LicenseStatus
            } else {
                // Not Required from 2023 onwards
                this._enrollGateWay.getEmailsSetting(this._global.Planyear2023, this._global.selectedPlanYear).subscribe((data) => {
                    this.validAgent = data
                    this.isRequired = !data

                    if (data) {
                        if (Number(this._global.selectedPlanYear) == this._global.Planyear2023) {
                            this.fortemp2023 = true
                            this.isRequired = true
                            this.for2022 = false
                            this.for2023 = false
                            this.validAgent = false
                        } else {
                            if (this._global.currentUser === undefined || Object.keys(this._global.currentUser).length == 0) {
                                this._currentUserGateway.getCurrentUser().subscribe((user) => {
                                    if (user != null) {
                                        this._global.currentUser = user
                                        if (this._global.selectedPlanYear === 0) {
                                            this.userdataservice.currentYear.subscribe((data) => {
                                                this._global.selectedPlanYear = data
                                                this.setPageData()
                                            })
                                        } else {
                                            this.userdataservice.changeMessage(true)
                                            this.setPageData()
                                        }
                                    }
                                })
                            } else {
                                this.setPageData()
                            }
                        }
                    } else {
                        if (Number(this._global.selectedPlanYear) >= this._global.Planyear2023) {
                            this.for2022 = false
                            this.for2023 = true
                            this.fortemp2023 = false
                        } else {
                            this.for2022 = true
                            this.for2023 = false
                            this.fortemp2023 = false
                        }
                    }
                })
            }
        } else {
            this.setGoodStandingStatus()
        }
    }

    checkGoodStandingStatus() {
        this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
        if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
            this.haserror = true
            this.validAgent = false
            //this.beneficiaryNameError = 'You are not in good standing either you have not passed training or background check is failed.'
            this.trainingMsg = !this.goodStandingValues.CurriculumStatus
            this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
            this.licencemsg = !this.goodStandingValues.LicenseStatus
        }
    }

    setGoodStandingStatus() {
        if (
            this._global.currentUser === undefined ||
            this._global.currentUser.insuranceCompanyId === undefined ||
            this._global.currentUser.insuranceCompanyId === null
        ) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    if (this._global.selectedPlanYear === 0) {
                        this.loadPlanYear()
                    } else {
                        this.setGoodStanding()
                    }
                }
            })
        } else {
            this.setGoodStanding()
        }
    }

    loadPlanYear() {
        this._networkUserAccessGateway.getCurrentPlanYears().subscribe((planYears) => {
            this._global.availablePlanYears = planYears
            this.userdataservice.changeAvailableYears(planYears)
            if (planYears !== null) {
                if (planYears.length > 1) {
                    // making the max logic eloborate so that if we change planyears
                    // from number to a complex object its easy to accomodate.
                    var planYearStr: any
                    planYearStr = sessionStorage.getItem('PLANYEAR')
                    if (planYearStr === null || planYearStr === 0) {
                        let currentyear = moment().get('year')
                        if (currentyear === planYears[0]) this._global.selectedPlanYear = planYears[0]
                        else if (currentyear === planYears[1]) this._global.selectedPlanYear = planYears[1]
                        else this._global.selectedPlanYear = planYears[0]
                    } else {
                        this._global.selectedPlanYear = Number(planYearStr)
                    }
                }
            }
            this.setGoodStanding()
        })
    }

    setGoodStanding() {
        if (this._global !== undefined && this._global.selectedPlanYear !== 0) {
            this.commonGateway.getGoodStandingDetails(this._global.currentUser.userProfileId, String(this._global.selectedPlanYear)).subscribe(
                (model: GoodStandingModel) => {
                    if (model.GoodStandingStatus !== undefined && model.GoodStandingStatus !== null && model.GoodStandingStatus) {
                        sessionStorage.setItem('GoodStandingParams', JSON.stringify(model))
                    } else {
                        sessionStorage.setItem('GoodStandingParams', JSON.stringify(model))
                    }

                    this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
                    if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                        this.haserror = true
                        this.validAgent = false
                        //this.beneficiaryNameError = 'You are not in good standing either you have not passed training or background check is failed.'
                        this.trainingMsg = !this.goodStandingValues.CurriculumStatus
                        this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
                        this.licencemsg = !this.goodStandingValues.LicenseStatus
                    } else {
                        this.setPageData()
                    }
                },
                (error) => {
                    console.log(error)
                }
            )
        }
    }

    setPageData() {
        this.validAgent = true
        this.isRaddioConsidered = false
        this.emailSubmitForm = {} as SubmitEmailForm
        this.options = [] as ValidatedRadioButtonModel[]
        this.options.push({ value: 'Yes', htmlLabel: 'I Agree' }, { value: 'No', htmlLabel: 'I Disagree' })
        this.islicensed = false
        this.isAgree = false
        this.emailSendConfirmation = ''
        this.enableSubmit = true
        this.route.params.subscribe((params) => {
            if (params['email'] !== undefined) {
                this.emailSubmitForm.BeneficiaryEmail = params['email']
            }
        })
        this.route.queryParams.subscribe((params) => {
            if (params['email'] !== undefined) {
                this.emailSubmitForm.BeneficiaryEmail = params['email']
            }
        })
        this.getState()
    }

    selectedRbtn(event: any) {
        this.isAgree = event === 'Yes' ? true : false
        this.isRaddioConsidered = true
        if (!this.isAgree) {
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.router.navigate(['/' + insCo + '/home'])
        }
    }

    enableButton() {
        if (this.isAgree) {
            return true
        }
    }

    getState(): void {
        this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this._global.currentUser.userProfileName).subscribe((states: State[]) => {
            this.states = states
            this.states.unshift({ text: 'Select State', value: '0' })
            this.emailSubmitForm.State = '0'
        })
    }

    checkLicense() {
        console.log(this.emailSubmitForm.State)
        this.states.forEach((item) => {
            if (item.value === this.emailSubmitForm.State) {
                // console.log(item.text)
                this.selectedStateText = item.text
            }
        })
        if (!(this.emailSubmitForm.State === '0')) {
            this._enrollGateWay.CheckLicense(this.emailSubmitForm.State).subscribe((data: any[]) => {
                if (data.length > 0) {
                    this.islicensed = true
                } else {
                    this.islicensed = false
                    //this.hasError = true
                }
                console.table(data)
                console.log(this.islicensed)
            })
        }
        //if (this.emailSubmitForm.State === 'ID')//IDAHO
        //{
        //    this.islicensed = false;
        //    this.licenseError = 'Oops! Our records show that you don’t have an active license for the state of VA .'+
        //   ' The Enrollment Email has not been sent to your client.Please provide any missing licenses to your upline admin to have your SilverScript agent profile updated'
        //}
        //else {
        //    this.islicensed = true;

        //    this.licenseError = '';
        //}
    }

    submitForm() {
        //console.log('Name' + this.emailSubmitForm.BeneficiaryName)
        //console.log('Email' + this.emailSubmitForm.BeneficiaryEmail)
        //console.log('State' + this.emailSubmitForm.State)
        this.hasEmailError = false
        this.EmailError = ''
        this.hasError = false
        this.isSuccess = false
        this.emailSendConfirmation = ''
        let saveEmailModel: SaveEmailModel = new SaveEmailModel()
        let sendEmailModel: SendEmailModel = new SendEmailModel()

        saveEmailModel.BeneficiaryEmail = this.emailSubmitForm.BeneficiaryEmail

        sendEmailModel.BeneficiaryEmail = this.emailSubmitForm.BeneficiaryEmail
        sendEmailModel.BeneficiaryName = this.emailSubmitForm.BeneficiaryName

        if (!this.validateForm()) {
            return
        } else {
            if (this.isAgree) {
                this.enableSubmit = false
                this.hasEmailError = false
                this.EmailError = ''
                this.commonGateway.getGoodStandingDetails(this._global.currentUser.userProfileId, String(this._global.selectedPlanYear)).subscribe(
                    (model: GoodStandingModel) => {
                        if (model !== undefined && model !== null && model) {
                            if (!this._global.currentUser.IsEnoller && !model.GoodStandingStatus) {
                                if (!model.CurriculumStatus) {
                                    this.hasError = true
                                    this.beneficiaryNameError =
                                        'You must pass the ' +
                                        this._global.selectedPlanYear +
                                        ' Training and Certification before you can use this feature.'
                                } else if (!model.BackgroundCheckStatus) {
                                    this.hasError = true
                                    this.beneficiaryNameError = 'You must pass the background check before using this feature.'
                                }
                            } else {
                                this.hasError = false
                                this.beneficiaryNameError = ''
                                this._enrollGateWay.saveEnrollmentEmail(saveEmailModel, this._global.selectedPlanYear).subscribe(
                                    (model: any) => {
                                        if (model.toString() === 'Error') {
                                            this.enableSubmit = true
                                            this.hasEmailError = true
                                            this.EmailError =
                                                'Cannot send email to beneficiary. They have an outstanding enrollment link already sent. Please contact your administrator.'
                                        } else {
                                            console.log('Email Data Saved')
                                            this.enableSubmit = true
                                            console.log('Returned from Same Email ' + model)
                                            this._enrollGateWay
                                                .SendEmail(
                                                    this.emailSubmitForm.BeneficiaryEmail,
                                                    this.emailSubmitForm.BeneficiaryName,
                                                    model,
                                                    this._global.selectedPlanYear.toString()
                                                )
                                                .subscribe((data: string) => {
                                                    this.emailSendConfirmation =
                                                        'An email has been sent to the beneficiary containing an enrollment link.'
                                                    this.emailSubmitForm.BeneficiaryName = ''
                                                    this.emailSubmitForm.BeneficiaryEmail = ''
                                                    this.emailSubmitForm.State = '0'
                                                    this.hasError = false
                                                    this.isSuccess = true
                                                    console.log(data)
                                                })
                                        }
                                    },
                                    (error) => {
                                        console.log(error)
                                        console.log('Email Data Not Saved')
                                    }
                                )
                            }
                        } else {
                            // this.readyToSellIcon = 'NotReady'
                        }
                    },
                    (error) => {
                        console.log('Email Data Not Saved')
                    }
                )
            }
        }
    }

    validateForm(): boolean {
        let isFormValid: boolean = false
        let beneficiaryNameRequired: boolean = false
        let beneficiaryEmailRequired: boolean = false

        let beneficiaryNameValid: boolean = false
        let beneficiaryEmailValid: boolean = false
        let stateValid: boolean = false

        if (
            this.emailSubmitForm.BeneficiaryName === undefined ||
            this.emailSubmitForm.BeneficiaryName === '' ||
            this.emailSubmitForm.BeneficiaryName === null
        ) {
            beneficiaryNameValid = false
            beneficiaryNameRequired = false
            this.hasError = true
            this.beneficiaryNameError = "'Beneficiary Name’ is required."
            this.specialCharacterBeneficiaryNameError = ''
        } else {
            if (/^[a-zA-Z\s]*$/.test(this.emailSubmitForm.BeneficiaryName)) {
                this.beneficiaryNameError = ''
                this.specialCharacterBeneficiaryNameError = ''
                beneficiaryNameValid = true
                beneficiaryNameRequired = true
            } else {
                this.beneficiaryNameError = ''
                this.specialCharacterBeneficiaryNameError = "'Beneficiary Name’ is Invalid."
                beneficiaryNameValid = false
                beneficiaryNameRequired = true
                this.hasError = true
            }
        }

        if (
            this.emailSubmitForm.BeneficiaryEmail === undefined ||
            this.emailSubmitForm.BeneficiaryEmail === '' ||
            this.emailSubmitForm.BeneficiaryEmail === null
        ) {
            beneficiaryEmailValid = false
            beneficiaryEmailRequired = false
            this.beneficiaryEmailError = "'Beneficiary Email Address' is required."
            this.hasError = true
            this.specialCharacterbeneficiaryEmailError = ''
        } else {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.emailSubmitForm.BeneficiaryEmail.toLowerCase(),
                regexVal = new RegExp(
                    `^` +
                        `(` +
                        `?:[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"` +
                        `${unicodeRange}*"` +
                        `)` +
                        `@` +
                        `(` +
                        `?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+` +
                        `[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|` +
                        `\\[` +
                        `(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}` +
                        `(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:${unicodeRange}+)` +
                        `\\]` +
                        `)` +
                        `$`
                )
            let isOrgEmailValid = regexVal.test(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.beneficiaryEmailError = ''
                beneficiaryEmailRequired = true
                this.specialCharacterbeneficiaryEmailError = "'Beneficiary Email Address' is Invalid."
                beneficiaryEmailValid = false
            } else {
                this.beneficiaryEmailError = ''
                this.specialCharacterbeneficiaryEmailError = ''
                beneficiaryEmailValid = true
                beneficiaryEmailRequired = true
            }
        }

        if (!this.isRaddioConsidered) {
            this.radioCheckError = '*Please Select Agree / Disagree to Continue...'
            this.hasError = true
        } else {
            this.radioCheckError = ''
        }

        if (
            this.emailSubmitForm.State === 'Select State' ||
            this.emailSubmitForm.State === '' ||
            this.emailSubmitForm.State === undefined ||
            this.emailSubmitForm.State === '0'
        ) {
            this.stateSelectError = '‘Beneficiary State’ of Residence is required.'
            this.hasError = true
            stateValid = false
        } else {
            this.stateSelectError = ''
            stateValid = true

            if (this.islicensed) {
                this.licenseError = ''
            } else {
                this.licenseError =
                    'Oops! Our records show that you don’t have an active license for the state of ' +
                    this.selectedStateText +
                    '.' +
                    ' <br/>The Member Email has not been sent to your Member.<br/>Please provide any missing licenses to your upline admin to have your SilverScript agent profile updated.'
                this.hasError = true
            }
        }

        if (this.hasError) {
            this.focusableEleTop.nativeElement.focus()
        }

        if (
            beneficiaryNameRequired &&
            beneficiaryEmailRequired &&
            beneficiaryEmailValid &&
            beneficiaryNameValid &&
            this.isRaddioConsidered &&
            stateValid &&
            this.islicensed
        )
            isFormValid = true

        return isFormValid
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.submitForm()
        }
    }
    GetTrainingURL() {
        /*
        this.trainingCertificatesGateway.LogintoCourseGuide(this._global.currentUser.userProfileName,
            this._global.selectedPlanYear).subscribe
            ((data) => {
                window.open(data, '_blank')
            })
        */
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigate(['/' + insCo + '/training/trainingDetail'])
    }
}
